<template lang="html">

  <section class="destacados pad-sec">
    <div class="container">
      <h2 class="title title-36">{{$t('actualidad.noticias.titulo')}}</h2>
      <div class="flex wrap justify-around">
        <template v-if="!!noticias">
          <noticia-el v-for="(e, key) in noticiasProcessed" :data="e" :key="key"></noticia-el>
        </template>
        <template v-else>
          <noticia-fake v-for="(e, key) in 6" :key="key"></noticia-fake>
        </template>
      </div>
    </div>
    <router-link class="btn btn-dark btn-center -pink-full" v-if="!small" :to="$t('enlaces.blog')" target="_blank">{{$t('actualidad.noticias.ir_blog')}}</router-link>
  </section>

</template>

<script lang="js">


  import Vue from 'vue'
  import axios from 'axios'
  import { setMetaContent } from '@/seo/head'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';
  import Noticia_fake from '@/components/parts/noticia-fake';

  import { mapGetters } from 'vuex'


  export default  {
    name: 'noticias',
    props: ['small'],
    created() {
      this.getData();
    },
    data() {
      return {
        noticias : '',
        destroyed : false
      }
    },
    beforeDestroy () {
      // La vista de categoria destruye este arbol al mostrar la 404, pero su
      // peticion sigue en vuelo: sin esta bandera, `$t` se ejecuta sobre una
      // instancia ya desmontada y lanza TypeError.
      this.destroyed = true;
    },
    computed: {
      noticiasProcessed : function (){
        let count = (this.small) ? '3' : this.noticias.length;
        return this.noticias.slice(0,count);
      },
      ...mapGetters({
        lang : 'getLanguage'
      })
    },
    methods : {
      getData (){
        axios.get(`actualidad?lang=${this.lang}`)
        .then(response => {
          this.noticias = response.data.noticias;

          this.applyCategoryMeta();
        })
        .catch(error => console.log(error));
      },
      /**
       * Metadatos propios de la categoria de blog, solo si existen.
       *
       * Este componente lo comparten `categoria-blog.vue` y `actualidad.vue`,
       * pero la ruta de actualidad NO lleva `id`: la clave quedaba como
       * `enlaces.seo.blog_categoria.undefined.title` y vue-i18n devuelve la
       * clave cuando no hay traduccion, asi que se escribia tal cual en el
       * <title> y en la meta description. Ademas pisaba los metadatos correctos
       * que el router ya habia aplicado desde `meta.seo` (`enlaces.seo.actualidad`
       * si existe, y esta bien, en los cinco idiomas).
       *
       * Lo mismo pasaba con las categorias que no tienen `description` propia
       * (`productos` y `nuestro-sector`).
       */
      applyCategoryMeta () {
        const id = this.$route.params.id;
        // Sin id es la pagina de actualidad: conserva lo que puso el router.
        if (!id) return;

        const title = this.translatedOrNull(`enlaces.seo.blog_categoria.${id}.title`);
        const description = this.translatedOrNull(`enlaces.seo.blog_categoria.${id}.description`);

        if (title) {
          document.title = title;
          setMetaContent("[property='og:title']", 'meta', { property: 'og:title' }, title);
        }
        if (description) {
          setMetaContent('[name=description]', 'meta', { name: 'description' }, description);
          setMetaContent("[property='og:description']", 'meta', { property: 'og:description' }, description);
        }
      },
      /** vue-i18n devuelve la propia clave cuando no hay traduccion. */
      translatedOrNull (key) {
        const value = this.$t(key);
        return value && value !== key ? value : null;
      }
    },
    watch : {
      'lang'(){
        this.getData();
        this.$router.push({ name: "blog" })
      }
    },
    components: {
      'noticia-el' : Noticia_el,
      'noticia-fake' : Noticia_fake
    }
  }
</script>

<style scoped>
.noticias {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/actualidad-parts/noticias.vue